import * as React from 'react';
import { connect } from 'react-redux';
import { Breadcrumb } from 'antd';
import IntlMessages from '../../components/utility/intlMessages';
import { push } from 'react-router-redux';
import { buildUrl, generateRandom } from '../../helpers/utility';
import * as R from 'ramda';

const pages = ['projects', 'project', 'account', 'contact', 'enquiry', 'lead', 'setting', 'dashboard', 'addnewproject', 'calendar', 'employee', 'contactOrEnquiry', 'office', 'propertyOrProject', 'properties', 'property', 'addProperty'];
class SagaBreadCrumb extends React.Component<any, any>{

    public getTagName(tag, isDetail) {
        if (tag) {
            switch (tag) {
                case 'projects':
                    return 'sidebar.projectList';
                case 'project':
                    return isDetail === true ? 'sidebar.projectDetail' : 'sidebar.projectList';
                case 'addnewproject':
                    return 'sidebar.addProject';
                case 'account':
                    return 'sidebar.account';
                case 'contact':
                    return isDetail === true ? 'sidebar.contactDetail' : 'sidebar.contacts';
                case 'enquiry':
                    return isDetail === true ? 'sidebar.enquiryDetail' : 'sidebar.enquiry';
                case 'lead':
                    return isDetail === true ? 'lead.leadDetail.header' : 'sidebar.lead';
                case 'setting':
                    return 'sidebar.settings';
                case 'dashboard':
                    return 'dashboard';
                case 'calendar':
                    return 'sidebar.calendar';
                case 'employee':
                    return isDetail ? 'setting.menu.employee.detail' : 'sidebar.settings.employeelist';
                case 'contactOrEnquiry':
                    return 'setting.menu.enquiry.status';
                case 'office':
                    return isDetail ? 'setting.office.officeDetail' : 'sidebar.settings.officelist';
                case 'propertyOrProject':
                    return 'setting.menu.propertyAndProject.status';
                case 'properties':
                    return 'sidebar.propertyList';
                case 'property':
                    return isDetail === true ? 'sidebar.property' : 'sidebar.propertyList';
                case 'addProperty':
                    return 'propertyList.addProperty';
                case 'propertylist':
                    return 'sidebar.propertyList';
                default:
                    return '';
            }
        }
    }

    public getUrl(tag, isDetail, val) {
        if (tag) {
            switch (tag) {
                case 'projects':
                    return '/dashboard/projects';
                case 'project':
                    return isDetail === true ? '/dashboard/project/' + val : '/dashboard/projects';
                case 'addnewproject':
                    return '/dashboard/addnewproject/';
                case 'contact':
                    return isDetail === true ? '/dashboard/account/contact/' + val : '/dashboard/account/contact';
                case 'enquiry':
                    return isDetail === true ? '/dashboard/account/enquiry/' + val : '/dashboard/account/enquiry';
                case 'lead':
                    return isDetail === true ? '/dashboard/account/lead/' + val : '/dashboard/account/lead';
                // case 'setting':
                //     return '/dashboard/setting';
                case 'dashboard':
                    return '/dashboard';
                case 'calendar':
                    return '/dashboard/calendar';
                case 'employee':
                    return '/dashboard/setting/employee/';
                case 'contactOrEnquiry':
                    return '/dashboard/setting/contactOrEnquiry/';
                case 'office':
                    return '/dashboard/setting/office/';
                case 'propertyOrProject':
                    return '/dashboard/setting/propertyOrProject';
                case 'properties':
                    return '/dashboard/properties';
                case 'property':
                    return isDetail === true ? '/dashboard/property/' + val : '/dashboard/properties';
                default:
                    return '';
            }
        }
    }

    public render() {
        // get root path
        const routerpath = (this.props.router && this.props.router.location) ? this.props.router.location.pathname : '';
        // remove dashboard from root path
        const dashboardIndex = (routerpath && routerpath !== null && routerpath.length > 0) ? routerpath.indexOf('/dashboard') : -1;
        const path = dashboardIndex >= 0 ? routerpath.substring(dashboardIndex, routerpath.length) : routerpath;
        // split path for check current page
        const pathSplit = (path && path !== null && path.length > 0) ? path.split('/') : [];
        const menu = [];
        if (pathSplit && pathSplit !== null && pathSplit.length > 0) {
            const maxLength = pathSplit.length;
            for (let i = 0; i < maxLength; i++) {
                const text = pathSplit[i];
                if (!(text) || text === null || text === '') {
                    continue;
                }
                // check this is main/list or detail page
                const isDetail = !R.contains(text, pages);
                // get page's name
                const primaryPage = isDetail ? pathSplit[i - 1] : text;
                const tagName = isDetail ? this.getTagName(primaryPage, isDetail) : this.getTagName(primaryPage, isDetail);
                // condition for special pages 
                if (primaryPage === 'addnewproject') {
                    menu.push({ tagName: this.getTagName('projects', false), url: this.getUrl('projects', false, text) });
                }
                else if(primaryPage === 'addProperty') {
                    menu.push({ tagName: this.getTagName('properties', false), url: this.getUrl('properties', false, text) });
                }
                menu.push({ tagName, url: this.getUrl(primaryPage, isDetail, text) });
            }
        }
        return (
            (menu && menu !== null && menu.length > 0) ?

                <Breadcrumb style={{ paddingLeft: '1rem', paddingTop: '0.5rem' }}>
                    {
                        menu.map((item, index) => {
                            return index === menu.length - 1 || item.url === ''
                                ? <Breadcrumb.Item key={generateRandom()}><IntlMessages id={item.tagName} /></Breadcrumb.Item>
                                : <Breadcrumb.Item key={generateRandom()}><a href='javascript:void(0)' onClick={() => this.props.push(buildUrl(item.url))}><IntlMessages id={item.tagName} /></a></Breadcrumb.Item>;
                        })
                    }
                </Breadcrumb>
                : null
        );
    }

}

const mapStateToProps = (state) => {
    return {
        router: state.router
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        push: (location) => dispatch(push(location)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SagaBreadCrumb);



// WEBPACK FOOTER //
// ./src/components/utility/breadcrumb.tsx